// extracted by mini-css-extract-plugin
module.exports = {"cardSquare":"zrJsd","searchImage":"MluX9"};